/**
 * Renders a QR (SVG) from an arbitrary text, with the `qrcode` library.
 *
 * On a solid white background (reliable contrast in any theme; a QR needs a
 * quiet zone and high contrast). Exposes `data-value` with the encoded text so
 * that tests verify WHAT the QR encodes without decoding the image.
 */

import { createEffect, createSignal } from "solid-js";
import QRCode from "qrcode";

export function QrCode(props: { value: string; size?: number; testid?: string }) {
  const [svg, setSvg] = createSignal("");

  createEffect(() => {
    void QRCode.toString(props.value, {
      type: "svg",
      margin: 1,
      errorCorrectionLevel: "M",
      color: { dark: "#0b0b12ff", light: "#ffffffff" },
    })
      .then((out) => setSvg(out))
      .catch(() => setSvg(""));
  });

  return (
    <div
      data-testid={props.testid ?? "qr-code"}
      data-value={props.value}
      class="inline-flex items-center justify-center rounded-2xl bg-white p-3 shadow-sm"
      style={{ width: `${props.size ?? 200}px`, height: `${props.size ?? 200}px` }}
      // oxlint-disable-next-line solid/no-innerhtml
      innerHTML={svg()}
    />
  );
}
